import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/react'
import './index.css'
import App from './App.jsx'
import config from './config'

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// In dev-auth preview mode, skip ClerkProvider entirely.
const tree = config.devAuth ? (
  <App />
) : (
  <ClerkProvider publishableKey={clerkPubKey} afterSignOutUrl="/login">
    <App />
  </ClerkProvider>
)

createRoot(document.getElementById('root')).render(
  <StrictMode>{tree}</StrictMode>,
)
